"use client"

import * as React from "react"
import { Accordion as AccordionPrimitive } from "radix-ui"
import { ChevronDownIcon } from "lucide-react"

import { cn } from "@/components/ui/utils"

function Accordion({
  className,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Root>) {
  return (
    <AccordionPrimitive.Root
      data-slot="accordion"
      className={cn("w-full", className)}
      {...props}
    />
  )
}

function AccordionItem({
  className,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Item>) {
  return (
    <AccordionPrimitive.Item
      data-slot="accordion-item"
      className={cn(
        "overflow-hidden rounded-[1.35rem] border border-[hsl(var(--line)/0.8)] bg-[linear-gradient(180deg,rgba(255,252,246,0.98),rgba(250,244,235,0.98))] shadow-soft transition-all duration-200 data-[state=open]:border-[hsl(var(--maroon)/0.22)] data-[state=open]:shadow-[0_10px_28px_hsl(var(--maroon)/0.08)] hover:border-[hsl(var(--maroon)/0.14)] hover:shadow-[0_8px_22px_hsl(var(--maroon)/0.08)]",
        className,
      )}
      {...props}
    />
  )
}

function AccordionTrigger({
  className,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Trigger>) {
  return (
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger
        data-slot="accordion-trigger"
        className={cn(
          "flex w-full items-center justify-between gap-4 px-6 py-5 text-left text-base font-semibold tracking-tight text-[hsl(var(--ink))] transition-colors hover:text-[hsl(var(--maroon))] data-[state=open]:text-[hsl(var(--maroon))] sm:text-[1.05rem] [&[data-state=open]>svg]:rotate-180",
          className,
        )}
        {...props}
      >
        <span className="min-w-0 flex-1">{children}</span>
        <ChevronDownIcon className="pointer-events-none size-5 shrink-0 text-[hsl(var(--muted-foreground))] transition-transform duration-200" />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  )
}

function AccordionContent({
  className,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Content>) {
  return (
    <AccordionPrimitive.Content
      data-slot="accordion-content"
      className={cn(
        "overflow-hidden text-base leading-relaxed text-[hsl(var(--ink)/0.82)] data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
        className,
      )}
      {...props}
    >
      <div className="space-y-4 px-6 pb-6 pt-2">{children}</div>
    </AccordionPrimitive.Content>
  )
}

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent }
